import React, { useEffect, useState, useContext } from "react";
import { useLocation, Outlet, Route, Routes, useNavigate, useParams } from "react-router-dom";
import { useAlert } from "react-alert";

import { Card, GrayCardTitle, SubCard, SubCardContainer, SubCardTitle, SessionsContainer, RightAlignedButton } from "../../common_components/Layout";
import { PrimaryButton, SecondaryButton } from "../../common_components/Buttons";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { parseSurveyJson } from "../../common_components/SurveyHelpers";
import { NewSurveyDetailCard } from "../../missions_components/sub_page_components/SurveyOverviewCard";


// Api Calls
import SurveyAPI from "../../../api/api_calls/SurveyAPI";


function SurveyCard(props) {

    const navigate = useNavigate();
    const alert = useAlert();
    const { missionId } = useParams()
    const [loadingSurvey, setLoadingSurvey] = useState(true);
    const [surveyJson, setSurveyJson] = useState({});
    const [surveyQuestions, setSurveyQuestions] = useState([]);

    const [questionCount, setQuestionCount] = useState(-1);
    const [surveyLength, setSurveyLength] = useState(-1);

    const additionalStyle = { borderRadius: "4px", border: "1px solid #7c7c7c" }

    useEffect(() => {
        async function getSurvey() {
            const response = await SurveyAPI.showSurvey({ missionId: missionId, handleRedirect: navigate });
            if (response.success) {
                if (response.survey_exists) {
                    setSurveyJson(response.survey_json);
                    setSurveyQuestions(parseSurveyJson(response.survey_json))

                    setQuestionCount(response.question_count);
                    setSurveyLength(response.survey_length);
                    setLoadingSurvey(false);
                } else {
                    setSurveyJson({});
                    setQuestionCount(0);
                    setScreeningQuestionCount(0);
                    setLoadingSurvey(false);
                }
            } else {
                alert.show(response.error, { type: 'error' })
            }
        }

        // Set the path for the button if there's a direct link.
        getSurvey();
    }, [])


    return (
        <Card>
            <GrayCardTitle title="Survey" />
            {loadingSurvey ? <CenteredLoadingIcon /> :
                <NewSurveyDetailCard loadingSurvey={loadingSurvey} questionCount={questionCount} surveyQuestions={surveyQuestions} isScreener={false} alertButton={true} />

            }
        </Card>

    )
}

export default SurveyCard;